import { createContext } from 'react';


interface PanderFormContextProps {
  isLoading: boolean;
  showForm: boolean;
  errorMessage: string;
  openForm: () => void;
  closeForm: () => void;
}

export const PanderFormContext = createContext<PanderFormContextProps>({
    isLoading: false,
    showForm: false,
    errorMessage: '',
    closeForm: () => {},
    openForm: () => {}

});